import React, { useEffect, useState } from 'react';
import { X, Copy, Truck } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';

function formatear(d) {
  return [
    'Envío Última Milla:',
    `Guía: ${d.guia}`,
    `Destinatario: ${d.destinatario}`,
    `Cédula: ${d.cedula || '(sin cédula registrada)'}`,
    `Celular: ${d.celular || '(sin celular registrado)'}`,
    `Dirección: ${d.direccion || '(sin dirección registrada)'}`,
    `Ubicación: ${d.ubicacion || '(sin link de ubicación)'}`,
  ].join('\n');
}

/**
 * Trae cédula/celular/dirección del cliente vía /paquetes/<id>/datos_ultima_milla/
 * — la ÚNICA pantalla del panel donde el asistente ve esos campos, por
 * excepción puntual (ver paquetes/views.py, PaqueteViewSet.datos_ultima_milla).
 */
export default function UltimaMillaModal({ paquete, guiaOverride, onClose }) {
  const [texto, setTexto] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get(`/paquetes/${paquete.id}/datos_ultima_milla/`)
      .then((res) => {
        const data = guiaOverride ? { ...res.data, guia: guiaOverride } : res.data;
        setTexto(formatear(data));
      })
      .catch((err) => {
        toast.error(err.response?.data?.error || 'No se pudo generar el texto de última milla.');
        onClose();
      })
      .finally(() => setCargando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paquete.id]);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      toast.success('Copiado al portapapeles.');
    } catch {
      toast.error('No se pudo copiar automáticamente. Selecciona el texto y copia a mano.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Truck size={18} /> Última milla
          </h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        {cargando ? (
          <p className="text-secondary">Cargando...</p>
        ) : (
          <>
            <textarea readOnly rows={8} value={texto} style={{ fontFamily: 'var(--font-sans)' }} />
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>Cerrar</button>
              <button type="button" className="btn-primary" onClick={copiar}>
                <Copy size={16} /> Copiar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
